<template>
  <b-tab title="Clientes" class="m-0 p-0">
    <div class="tab-screen-list">
      <!-- :::::::::::::::::::::::::::: TABELA DE CLIENTES :::::::::::::::::::::::::::: -->
      <b-table bordered hover small head-variant="light" :items="getFilterClientes(filtro)" :fields="fields.cliente">
        <template #cell(acoes)="data">
          <div>
            <b-button class="pt-0 pb-0" variant="link" @click="editar(data.item)" v-b-tooltip.hover title="Editar">
              <b-icon icon="pencil-square" variant="primary"> </b-icon>
            </b-button>
            <b-button class="pt-0 pb-0" variant="link" @click="display(data.item)" v-b-tooltip.hover title="Logomarca">
              <b-icon icon="image" variant="info"> </b-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
    <!-- :::::::::::::::::::::::::::: BARRA DE AÇÕES :::::::::::::::::::::::::::: -->
    <div class="menu-acoes pb-2">
      <div id="search-bar">
        <b-col cols="10" class="p-1 pr-0">
          <b-form inline>
            <b-button size="sm" class="pl-2 pr-3" variant="info" @click="adicionar()">
              <b-icon icon="plus-circle" variant="light" scale="1.1" class="mr-2" />Adicionar
            </b-button>
            <b-form-input
              id="cliente-filter"
              type="search"
              size="sm"
              class="m-1 p-1"
              placeholder="Filtre pelo nome do cliente."
              v-model="filtro"
            />
            <b-icon icon="search" variant="light" scale="1.2" class="m-1" />
          </b-form>
        </b-col>
      </div>
      <!-- :::::::::::::::::::::::::::: MODAL DE EDIÇÃO :::::::::::::::::::::::::::: -->
      <cliente-modal ref="editor" />
      <display-modal ref="display" :size="'sm'" />
    </div>
  </b-tab>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useClienteStore } from "@/stores/ClienteStore";
import Cliente from "@/models/Cliente";
import TableFields from "@/tools/TableFields";
import ClienteModal from "@/components/modals/cliente/ClienteModal";
import DisplayModal from "@/components/modals/diversos/DisplayModal";
import Files from "@/http/files";

export default {
  name: "ClienteTabList",

  data() {
    return {
      fields: new TableFields(),
      filtro: "",
      cliente: new Cliente(0, "Novo Cliente", "", "", "", "", "", "", ""),
      files: new Files(this.$http),
    };
  },

  components: {
    "cliente-modal": ClienteModal,
    "display-modal": DisplayModal,
  },

  methods: {
    adicionar() {
      this.cliente = new Cliente(0, "Novo Cliente", "", "", "", "", "", "", "");
      this.$refs.editor.call(this.cliente);
    },

    editar(cliente) {
      this.$refs.editor.call(cliente);
    },

    display(cliente) {
      this.files.downloadLogo(cliente.id).then((response) => this.$refs.display.call(response));
    },
  },

  setup() {
    const store = useSgcqStore();
    const clienteStore = useClienteStore();
    const { getFilterClientes } = storeToRefs(clienteStore);

    return {
      store,
      clienteStore,
      getFilterClientes,
    };
  },
};
</script>

<style lang="scss" scoped>
#cliente-filter {
  width: 30rem;
}
.menu-acoes {
  background-color: #112a4a;
}
</style>
